import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput, ReferenceInput, AutocompleteInput, NumberInput, BooleanInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <ReferenceInput
                source="pool"
                reference="dictionary/pool_companies"
                label={t('brief.pool')}
            >
                <AutocompleteInput optionText="name"/>
            </ReferenceInput>
            <NumberInput source="mpmId" label={'mpmId'}/>
            <BooleanInput source="isBriefManyProducts" label={t('admin.isBriefManyProducts')} defaultValue={false} />
            <BooleanInput source="isBriefManyChannels" label={t('admin.isBriefManyChannels')} defaultValue={false} />
        </CreateGuesser>
    )
}

export default Create
